import { render, staticRenderFns } from "./media-details.html?vue&type=template&id=6427b420&scoped=true&"
import script from "./media-details.js?vue&type=script&lang=js&"
export * from "./media-details.js?vue&type=script&lang=js&"
import style0 from "./media-details.scss?vue&type=style&index=0&id=6427b420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427b420",
  null
  
)

export default component.exports